module.exports = __webpack_public_path__ + "static/img/icon_c_fb.6fb35e59.svg";